<template>
  <div class='full-width'>
    <v-card>
      <v-card-title >Delete Documents:</v-card-title>
      <v-card-actions>
        <v-row>
          <v-spacer></v-spacer>
          <div
            class="button"
            v-for="doc in event.eventDocuments"
            v-bind:key="doc.documentId"
          >
            <v-btn
              outlined
              @click.native.stop
              @click="onDeleteDocument(event.eventId, doc.documentId)"
              ><v-icon left>mdi-delete</v-icon>{{ doc.title }}</v-btn
            >
          </div>
        </v-row>
      </v-card-actions>
    </v-card>

    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="400">
        <v-card>
          <v-card-title class="headline">{{
            deleteMessage
          }}</v-card-title>
          <v-card-text>{{ title }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined text @click="dialog = false"
              >No</v-btn
            >
            <v-btn outlined text @click="deleteDocument"
              >Yes</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <statusalert ref="alert" returnUrl="/schedule"></statusalert>
  </div>
</template>

<script>
import DocumentsService from '../services/api/DocumentsService.js'
import store from '@/store/index.js'
import EventsService from '../services/api/EventsService'
import statusalert from '../components/StatusAlert'

export default {
  name: 'delete-documents',
  props: ['event', 'events'],
  components: {
    statusalert,
  },

  store: store,

  data: () => ({
    dialog: false,
    deleteMessage: 'Delete the selected document?',
    eventDocumentId: 0,
    title: ''
  }),

  created() {
    this.getDocuments(this.event.eventId)
  },
  methods: {
    getDocuments(eventId) {
      store.commit('isLoading')

      EventsService.getEventDocuments(eventId)
        .then(documents => {
          this.event.eventDocuments = documents
        })
        .catch(error => console.log(error))
        .finally(() => {
          store.commit('notLoading')
        })
    },
    onDeleteDocument(eventId, documentId) {
      this.dialog = true
      // find the event
      const event = this.events.find(e => e.eventId === eventId)
      const document = event.eventDocuments.find(
        d => d.documentId === documentId
      )
      this.title = ''
      this.eventDocumentId = 0
      if (document) {
        this.eventDocumentId = documentId
        this.title = document.title
      }
    },

    deleteDocument() {
      let me = this
      DocumentsService.delete(this.eventDocumentId)
        .then(result => {
          me.result = {
            isValid: true,
            statusCode: result.status,
            errors: ['Document deleted']
          }
          this.$emit('documentdeleted')
        })
        .catch(error => {
          console.log(error)
          me.result = {
            isValid: false,
            statusCode: 404,
            errors: [error]
          }
        })
        .finally(() => {
          store.commit('notLoading')
          this.dialog = false
          this.$refs.alert.displayResult(me.result)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  padding: 5px;
}
.full-width {
  width: 100%;
}

</style>
